import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const NavStyles = styled.nav`
  height: 7rem;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .whatsapp-nav {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background: #25d366;
    transition: background 0.2s ease;

    svg {
      width: 2.2rem;
      height: 2.2rem;
      fill: white;
    }

    &:hover {
      background: #1da851;
    }

    @media (max-width: 769px) {
      display: none;
    }
  }

  ul {
    list-style: none;
    width: 400px;
    display: flex;
    justify-content: space-around;

    a {
      font-size: 1.6rem;
      color: #2d2d45;

      &:hover {
        color: var(--orange);
      }

      &[aria-current] {
        color: var(--orange);
      }
    }
  }

  .burger {
    display: none;
    cursor: pointer;

    div {
      width: 25px;
      height: 2px;
      background-color: #2d2d45;
      margin: 5px;
      transition: all 0.3s ease;
    }

    &.toggle {
      z-index: 999;
      .line1 {
        transform: rotate(-45deg) translate(-5px, 4px);
      }
      .line2 {
        opacity: 0;
      }
      .line3 {
        transform: rotate(45deg) translate(-5px, -5px);
      }
    }
  }

  @media (max-width: 769px) {
    padding: initial 6rem;
    justify-content: space-between;

    ul {
      flex-direction: column;
      background: white;
      position: fixed;
      justify-content: center;
      align-items: center;
      width: 100%;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 2;
      animation: slideOut 0.5s ease-in-out forwards;

      li {
        margin: 2rem 0;
        opacity: 0;
        transition: 2s ease-in-out all;
      }

      a {
        font-size: 2.8rem;
        font-weight: 400;
      }
    }

    .burger {
      display: block;
    }

    &.mobile-active {
      ul {
        animation: slideIn 0.8s ease-in-out forwards;
        z-index: 999;

        li {
          animation: linkAppear 2s ease-in-out forwards;
        }
      }

      @keyframes slideOut {
        to {
          transform: translateX(100%);
        }
      }

      @keyframes slideIn {
        from {
          transform: translateX(100%);
        }

        to {
          transform: translateX(0);
        }
      }

      @keyframes linkAppear {
        from {
          opacity: 0;
        }

        to {
          opacity: 1;
        }
      }
    }
  }
`;

const Nav = () => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);

  return (
    <>
      <Helmet
        bodyAttributes={mobileMenuActive ? { class: "no-scroll" } : {}}
      />
      <NavStyles className={mobileMenuActive && "mobile-active"}>
        <Link to="/">
          <StaticImage
            src={"../images/logo.svg"}
            alt="Hello Ephesus"
            layout="fixed"
            height={50}
            placeholder="none"
          />
        </Link>
        <ul>
          <li>
            <Link to="/" onClick={() => setMobileMenuActive(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/tours" onClick={() => setMobileMenuActive(false)}>
              Tours
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setMobileMenuActive(false)}>
              Contact
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setMobileMenuActive(false)}>
              About
            </Link>
          </li>
        </ul>
        <a
          className="whatsapp-nav"
          href="https://wa.me/905442723242"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
        >
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </a>
        <div
          className={`burger ${mobileMenuActive && "toggle"}`}
          onClick={() => setMobileMenuActive(!mobileMenuActive)}
        >
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>
      </NavStyles>
    </>
  );
};

export default Nav;
